export default "__VITE_ASSET__BkQftVRd__"